module.exports = __webpack_public_path__ + "img/ic_nav_workouts.52f2b734.svg";